<template>
  <div class="flex flex-col mb-5 pt-10 bg-EXPONDO-white">
    <ul class="list-none">
      <NavFooterLink
        v-for="link in navFooterLinks"
        :key="link.title || link.link"
        :title="link.title"
        :url="link.link"
        :tag="link.tag"
        class="hover:bg-EXPONDO-grey-5"
      />
    </ul>
  </div>
</template>

<script lang="ts">

import { getNavSidebarFooterLinks } from '~~/helpers/navigation/getNavSidebarFooterLinks';

export default defineComponent({
  name: 'NavFooterlinks',

  setup() {

    const { isExtraGuaranteeEnabled } = useStoreVsfExtended();
    const navFooterLinks = computed(() => getNavSidebarFooterLinks({
      isExtraGuaranteeEnabled: isExtraGuaranteeEnabled.value,
    }));

    return {
      navFooterLinks,
    };
  
  },
});

</script>
